import _ from 'underscore';

import {AnalyticsQuerySpecRequest} from 'insights/analytics-queries/RESTAnalyticsQueryTypes';

import {RESTAnalyticsDashboardLayoutRow} from './RESTLayoutTypes';

export default function syncLayoutToAnalyticsQueries(
  layoutRows: Array<RESTAnalyticsDashboardLayoutRow>,
  newAnalyticsQueries: Array<AnalyticsQuerySpecRequest>
): Array<RESTAnalyticsDashboardLayoutRow> {
  const newAnalyticsQueryIds = newAnalyticsQueries.map((analyticsQuery) => analyticsQuery.id);
  const newLayoutOrderedQueryIds = layoutRows
    .flatMap((row) => row.analyticsQueryIds)
    .filter((layoutAnalyticsQueryId) => newAnalyticsQueryIds.includes(layoutAnalyticsQueryId));

  const gridLayoutQueryIds = _.chunk(newLayoutOrderedQueryIds, 2) as Array<Array<string>>;

  return gridLayoutQueryIds.map((row) => ({
    analyticsQueryIds: row,
  }));
}
